// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const resetSearchParams = () => ({
    type: actions.RESET_DEALER_SEARCH_PARAMS,
});
